import { Box, Stack, IconButton, Button } from '@mui/material'
import { CertificateIcon, CloseIcon, ShareIcon } from './icons'
import { styles } from './styles'
import type { NotificationsListProps } from './types'
import { getNotificationText } from '../../modals'

export const NotificationsList = (props: NotificationsListProps) => {
  const { data, handleClear, handleClearAll, handleNavigate } = props

  //const handleRemove = () => {}
  //const handleNavigate = () => {}

  return (
    <Stack sx={styles.container}>
      <Stack sx={styles.list}>
        {data?.length > 0 ? (
          data?.map((item, index) => (
            <Stack sx={styles.notification} key={String(index)}>
              <Box sx={styles.icon}>
                {item?.icon ? item?.icon : <CertificateIcon />}
              </Box>
              <Stack style={{ width: '100%' }}>
                <Box sx={styles.title}>Уведомление</Box>
                {/* <Box sx={styles.message}>{item.message}</Box> */}
                <Box sx={styles.message}>{getNotificationText(item)}</Box>
              </Stack>
              <Stack sx={styles.buttons}>
                <IconButton
                  sx={styles.iconButton}
                  onClick={() => handleClear(index)}
                >
                  <CloseIcon />
                </IconButton>
                {item?.id && (
                  <IconButton
                    sx={styles.iconButton}
                    onClick={() => handleNavigate(item?.id)}
                  >
                    <ShareIcon />
                  </IconButton>
                )}
              </Stack>
            </Stack>
          ))
        ) : (
          <Box sx={styles.noNotifications}>Нет уведомлений</Box>
        )}
      </Stack>
      {data?.length > 0 ? (
        <Button
          variant="outlined"
          sx={styles.clearButton}
          onClick={handleClearAll}
        >
          Очистить все
        </Button>
      ) : null}
    </Stack>
  )
}
